import React from 'react'
import {
  ROICalculator,
  IProps as IROICalculator,
} from 'marketing-site/src/library/components/ROICalculator'
import { IRoiCalculator as IContentfulROICalculator } from 'marketing-site/@types/generated/contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { CTA } from 'marketing-site/src/transformers/CTA'

export const ContentfulROICalculator = (roiCalculator: IContentfulROICalculator) => (
  <EntryMarker entry={roiCalculator}>
    {() => <ROICalculator {...transformROICalculator(roiCalculator)} />}
  </EntryMarker>
)

export function transformROICalculator({ fields }: IContentfulROICalculator) {
  const transformedData: IROICalculator = {
    ...fields,
    renderCTA: () => fields.cta && <CTA {...fields.cta} />,
  }
  return transformedData
}
